import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  promoter: null,
  token: Cookies.get('token')
}

// getters
export const getters = {
  // Basic getters (backward compatibility)
  token: state => state.token,
  user: state => state.user,
  check: state => state.user !== null,

  // Enhanced getters
  isAuthenticated: state => Boolean(state.token && state.user),
  userRole: state => state.user?.role || 'guest',
  userName: state => state.user?.name || '',
  userEmail: state => state.user?.email || '',
  permissions: state => state.user?.permissions || [],
  
  // Authorization helpers
  hasPermission: (state) => (permission) => {
    const userPermissions = state.user?.permissions || []
    return userPermissions.includes(permission)
  },
  
  hasRole: (state) => (role) => {
    return state.user?.role === role
  },
  
  // Token validity
  hasValidToken: state => Boolean(state.token),
  
  // User status
  isAdmin: state => state.user?.role === 'admin',
  isPromoter: state => state.user?.role === 'promoter',
  isGuest: state => !state.user || state.user?.role === 'guest'
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    Cookies.remove('token')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null

    Cookies.remove('token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },


  async fetchPromoter ({ commit }) {
    try {
      const { data } = await axios.get('/api/promoter')

      commit(types.FETCH_USER_SUCCESS, { user: data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updatePromoter ({ commit }, payload) {
    commit(types.UPDATE_PROMOTER, payload)
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  },


  async fetchUser ({ commit }) {
    try {
      const { data } = await axios.get('/api/admin/user')

      commit(types.FETCH_USER_SUCCESS, { user: data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logoutUser ({ commit }) {
    try {
      await axios.post('/api/admin/logout')
    } catch (e) { }

    commit(types.LOGOUT)
  },

  async fetchOauthUrl (ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`)

    return data.url
  }
}

// Default export
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
